module.exports = __webpack_public_path__ + "static/img/upload-icon.994555b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon/upload-icon.png
// module id = 9BVc
// module chunks = 36